import { render, staticRenderFns } from "./Virtualmachine.vue?vue&type=template&id=2996c5c9&"
import script from "./Virtualmachine.vue?vue&type=script&lang=js&"
export * from "./Virtualmachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports